export { Slider, sliderVariants } from './Slider'
export type { SliderProps } from './Slider'
